import type { RootState } from '@/store/store';

export const selectToasts = (state: RootState) => state.notifications.toasts;
export const selectLatestToast = (state: RootState) => state.notifications.toasts[0];
